<template>
  <v-col>
    <h3 class="ml-2 mb-3">商品リンク情報</h3>
    <draggable
      v-model="product.productLinksAttributes"
      ghost-class="ghost"
      handle=".p-linkForm__handle"
      :animation="200"
      :force-fallback="true"
      :scroll-sensitivity="150"
      :scroll-speed="30"
    >
      <div
        v-for="(productLink, index) in product.productLinksAttributes"
        :key="index"
        class="my-1"
      >
        <product-link-form
          :product-link="productLink"
          :index="index"
          :product-link-styles="productLinkStyles"
          @delete-product-link="deleteProductLink(index)"
        />
      </div>
    </draggable>
    <div class="text-center">
      <v-btn
        color="indigo"
        dark
        rounded
        class="px-10 my-2"
        @click="addProductLink"
      >
        <v-icon>mdi-plus</v-icon>
        リンクを追加
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import draggable from 'vuedraggable'
import ProductLinkForm from '@/components/commons/products/ProductLinkForm'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  name: 'ProductLinkFormList',
  components: { ProductLinkForm, draggable },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return { productLinkStyles: [] }
  },
  mounted () {
    this.fetchProductLinkStyle()
  },
  methods: {
    addProductLink () {
      const productLinksAttribute = {
        productLinkStyleId: null,
        linkText: '',
        price: null,
        isTaxIncluded: null,
        url: '',
        priority: 0
      }
      if (!this.product.productLinksAttributes) {
        this.$set(this.product, 'productLinksAttributes', [])
      }
      this.product.productLinksAttributes.push(productLinksAttribute)
    },
    deleteProductLink (index) {
      this.product.productLinksAttributes.splice(index, 1)
    },
    fetchProductLinkStyle () {
      axios.get('/api/product_link_styles').then(({ data }) => {
        this.productLinkStyles.push(...deserialize(data).data)
      })
    }
  }
}
</script>
